import React from "react";
import "./DropdownMenu.css";
import { useNavigate } from "react-router-dom";

interface DropdownMenuProps {
  realm: string;
  onFeedbackClick: () => void;
  onLogout: () => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  realm,
  onFeedbackClick,
  onLogout,
}) => {
  const navigate = useNavigate();
  return (
    <div className="dropdown-menu">
      <p
        className="dropdown-item-text"
        style={{ borderBottom: "1px solid gray" }}
      >
        {realm}
      </p>
      <button
        onClick={onFeedbackClick}
        className="dropdown-item improve-plan-button"
      >
        Dejá tu opinión
      </button>

      {/* <button
        onClick={() => navigate("/select-plan")}
        className="dropdown-item improve-plan-button"
      >
        Mejorar plan
      </button> */}

      <button
        onClick={() => navigate("/change-password")}
        className="dropdown-item improve-plan-button"
      >
        Cambiar Contraseña
      </button>

      <button onClick={onLogout} className="dropdown-item logout-button">
        Cerrar sesión
      </button>
    </div>
  );
};

export default DropdownMenu;
